<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
      >        
        <material-card
          color="blue"
          title="Access Control"
        >
          <!-- <v-tooltip
            content-class="left"
            left
          >
            <v-btn 
              slot="activator"              
              fab 
              absolute 
              icon 
              round 
              top 
              right 
              @click="showAddSubscriptionDialog=true" 
              color="accent" 
              class="mr-3" 
              style="top:25px;" 
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            Add an new subscription. Go on! You're gonna love it!
          </v-tooltip> -->

          <div>
            <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Look for something..."
              single-line
              hide-details
              clearable
            ></v-text-field>
          </div>

          <v-data-table
            :headers="headers"
            :items="permissions"
            :search="search"            
            :pagination.sync="pagination"
          >
            <v-progress-linear v-slot:progress indeterminate></v-progress-linear>            
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td class="text-xs-left text-no-wrap">
                <div>
                  <v-icon>mdi-account-key</v-icon>
                  <!-- <a @click="navigateToDetails(item.id)" style="color:inherit;">{{item.name}}</a> -->
                  {{ item.userId }}
                </div>
              </td>
              <td class="text-xs-left hidden-sm-and-down">{{item.roleId}}</td>
              <td class="justify-center layout px-0">
                <!-- <v-icon
                  small
                  @click.stop="navigateToDetails(item.id)"
                  class="mr-2"
                >mdi-pencil</v-icon>
                <v-icon
                  small
                  :disabled="!canDeleteSub"
                  @click.stop="confirmRemoveSub(item)"
                >mdi-delete</v-icon> -->
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>


  </v-container>
</template>

<script>
import store from '@/store'
import { mapActions, mapGetters } from 'vuex'
import { Sentry } from '@/apis/sentry'

export default {
  components: {
  },
  
  data() {
    return {
      permissions: [],
      search: null,
      headers: [
        { text: 'User', align: 'left', value: 'name' },
        { text: 'Role', align: 'left', value: 'type' },
        { text: 'Actions', align: 'center', sortable: false, value: 'name' },
      ],
      pagination: {
        rowsPerPage: 10
      }
    }
  },

  mounted() {
    if (this.atmosInitialized) {
        this.loadPermissions();
    }
  },

  watch: {
    atmosInitialized: function(val, oldVal) {
        this.loadPermissions();
    },
  },

  computed: {
    ...mapGetters('atmos', [
      'atmosInitialized',
    ]),
  },

  asyncComputed: {
    // async canDeleteSub() {
    //   return await Sentry.hasPermission('SoftPro.Atmos', 'SoftPro.Atmos/Subscriptions/Delete');
    // }
  },

  filters: {
  },

  methods: {
    ...mapActions('atmos', [
    ]),

    async loadPermissions() {
      this.permissions = await Sentry.getPermissions('SoftPro.Atmos');
    },

    // navigateToDetails(id) {
    //   this.$router.push({ name: 'Subscription', params: { id: id } });
    // },

    // confirmRemoveSub(sub) {
    //   this.currentSub = sub;
    //   this.showConfirmRemoveSubDialog = true;
    // },

    // async removeSub() {
    //   await this.atmosRemoveSubscription(this.currentSub.name);
    // },

  }  

}
</script>
